import { Link } from "react-router-dom";

function ThankYou() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        className="w-12 h-12 text-black"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
        />
      </svg> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-12 w-12"
        style={{ height: "48px", width: "48px" }}
      >
        <path
          fill="#abaefc"
          d="M21.30285,10.07813A2.99076,2.99076,0,0,0,18.99963,9H14.44006l.484-1.29663a4.31847,4.31847,0,0,0,.16034-2.6919A4.13089,4.13089,0,0,0,11.113,2a1.00364,1.00364,0,0,0-.91705.59375L7.34887,9.0022V22H17.726a3.00077,3.00077,0,0,0,2.95233-2.46387l1.273-7A2.98989,2.98989,0,0,0,21.30285,10.07813Z"
        ></path>
        <path
          fill="#7479fb"
          d="M7.34985,9H5.00012a3.00328,3.00328,0,0,0-3,3v7a3.00328,3.00328,0,0,0,3,3H7.34887V9.0022Z"
        ></path>
      </svg>
      <h2
        style={{ textAlign: "center" }}
        className="text-xl py-4 font-semibold"
      >
        Thank you for requesting callback.
      </h2>
      <p className="text-lg">We'll get back to you soon.</p>
      <Link to="/">
        <span
          // onClick={() => helper.openWithParams("https://zyla.in")}
          className="text-primary no-underline font-bold py-4 text-lg cursor-pointer"
        >
          Back to homepage &rarr;
        </span>
      </Link>
    </div>
  );
}

export default ThankYou;
